<template>
  <div class="hello">
    <product-list></product-list>
  </div>
</template>

<script>
import ProductList from './ProductList';

export default {
  name: 'hello',
  data() {
    return {
    };
  },
  components : {
    ProductList,
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// Hello.vue?c3981b40